import React from "react";
import "./Certificates.css";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

function Certificates() {
  return (
    <div className="certificates">
      <Sidebar />
      <div className="certificates-container">
        <div className="certifications">
          <h1>My Certifications</h1>
          <table className="certifications-table">
            <thead>
              <tr>
                <th scope="col">Provider</th>
                <th scope="col">Certification</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <a
                    href="https://link-bucket-for-certs.s3.us-east-2.amazonaws.com/Poul+Zheng+-+CodeAcademy+Front-End+Engineer+(3).pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/codeacademy-logo.png"
                      alt="Codeacademy logo"
                      loading="eager"
                      id="codeacademy-logo"
                    />
                  </a>
                </td>
                <td>
                  <a
                    href="https://link-bucket-for-certs.s3.us-east-2.amazonaws.com/Poul+Zheng+-+CodeAcademy+Front-End+Engineer+(3).pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Front-End Engineer
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  <a
                    href="https://coursera.org/share/2847c3157a1fbf0278fb90f892ba4a8b"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/ibm-logo2.jpeg"
                      alt="IBM logo"
                      loading="eager"
                      id="ibm-logo"
                    />
                  </a>
                </td>
                <td>
                  <a
                    href="https://coursera.org/share/2847c3157a1fbf0278fb90f892ba4a8b"
                    target="_blank"
                    rel="noreferrer"
                  >
                    IBM Front-End Developer
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  <a
                    href="https://coursera.org/share/78da9e81910647cd25fd4125dafbb3fa"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/microsoft-logo.jpeg"
                      alt="Microsoft logo"
                      loading="eager"
                      id="microsoft-logo"
                    />
                  </a>
                </td>
                <td>
                  <a
                    href="https://coursera.org/share/78da9e81910647cd25fd4125dafbb3fa"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Microsoft IT Support Specialist
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  <a
                    href="https://verify.w3schools.com/5ZQK54D1J"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src="./img/W3Schools_logo.png"
                      alt="W3schools logo"
                      loading="eager"
                      id="w3schools-logo"
                    />
                  </a>
                </td>
                <td>
                  <a
                    href="https://verify.w3schools.com/5ZQK54D1J"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Certified HTML Developer
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Certificates;
